import { render, staticRenderFns } from "./UspItem.vue?vue&type=template&id=38697348&scoped=true&"
import script from "./UspItem.vue?vue&type=script&lang=js&"
export * from "./UspItem.vue?vue&type=script&lang=js&"
import style0 from "./UspItem.vue?vue&type=style&index=0&id=38697348&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38697348",
  null
  
)

export default component.exports